import DrawerAppBar from "./navbar";
const About =() => {
    return (
        <div>
        <DrawerAppBar/>
       <h1>THIS is about </h1></div>

    );
}
export default About;